import axiosConn from '../../axiosConn';

export const FEEDBACK_REWARD_PASS_SOURCE_VALUES = [
  'cl_creative_feedback',
  'hitlab_radio',
  'direct',
];
export const FEEDBACK_REWARD_PASS_CAMPAIGN_KEY = 'jg_radio_feedback_v1';
export const FEEDBACK_REWARD_PASS_REWARD_AMOUNT_JGK = 10000;
export const FEEDBACK_REWARD_PASS_REWARD_CASHOUT_VALUE_USD = 10;
export const FEEDBACK_REWARD_PASS_REWARD_COPY =
  '10,000 JGK - a $10 gross cashout value through JG Player';
export const VOICE_DROP_BONUS_REWARD_AMOUNT_JGK = 5000;
export const VOICE_DROP_BONUS_REWARD_CASHOUT_VALUE_USD = 5;
export const VOICE_DROP_BONUS_REWARD_COPY =
  '5,000 JGK - a $5 gross cashout value through JG Player';
export const FEEDBACK_REWARD_PASS_THRESHOLD = 10;

const SOURCE_SET = new Set(FEEDBACK_REWARD_PASS_SOURCE_VALUES);

const cleanText = (value, max = 256) =>
  String(value || '')
    .replace(/[\r\n\t]+/g, ' ')
    .trim()
    .slice(0, max);

export const normalizeFeedbackRewardPassSource = (value) => {
  const clean = cleanText(value, 120).toLowerCase();
  return SOURCE_SET.has(clean) ? clean : 'direct';
};

export const buildFeedbackRewardReturnTo = (source = 'direct') =>
  `/hitlab/radio?source=${normalizeFeedbackRewardPassSource(source)}&feedbackReward=1`;

export const FEEDBACK_REWARD_RETURN_TO = buildFeedbackRewardReturnTo(
  'cl_creative_feedback',
);

export const getFeedbackRewardPassSourceFromSearch = (search = '') => {
  const params = new URLSearchParams(search || '');
  return normalizeFeedbackRewardPassSource(params.get('source'));
};

export const shouldOpenFeedbackRewardPassFromSearch = (search = '') => {
  const params = new URLSearchParams(search || '');
  const keys = Array.from(params.keys());
  return (
    keys.length === 2 &&
    keys.every((key) => key === 'source' || key === 'feedbackReward') &&
    SOURCE_SET.has(params.get('source')) &&
    params.get('feedbackReward') === '1'
  );
};

export const buildFeedbackRewardPassLoginHref = (source = 'direct') =>
  `/login?from=${encodeURIComponent(buildFeedbackRewardReturnTo(source))}`;

export const buildFeedbackRewardAuthConfig = (player) =>
  player?.token
    ? {
        headers: {
          Authorization: `Bearer ${player.token}`,
        },
      }
    : undefined;

export const startFeedbackRewardPass = ({ player, source } = {}) =>
  axiosConn.post(
    'hitlab/radio/listener-feedback-rewards/start',
    { source: normalizeFeedbackRewardPassSource(source) },
    buildFeedbackRewardAuthConfig(player),
  );

export const getFeedbackRewardPass = ({ player } = {}) =>
  axiosConn.get(
    'hitlab/radio/listener-feedback-rewards/me',
    buildFeedbackRewardAuthConfig(player),
  );

export const submitFeedbackRewardPass = ({ player, feedback } = {}) =>
  axiosConn.post(
    'hitlab/radio/listener-feedback-rewards/submit',
    { feedback },
    buildFeedbackRewardAuthConfig(player),
  );

export const normalizeFeedbackRewardPassPayload = (response) => {
  const data = response?.data?.data || response?.data || {};
  return {
    pass: data.pass || null,
    progress: data.progress || data.pass?.progress || {
      threshold: FEEDBACK_REWARD_PASS_THRESHOLD,
      distinctTrackCount: 0,
      eligible: false,
      tracks: [],
    },
  };
};
